var render = function render(){var _vm=this,_c=_vm._self._c;return _c('body',{staticClass:"fixed-header",attrs:{"id":"apps"}},[_c('main-sidebar'),_c('main-header'),(_vm.is_loading)?_c('floating-loader-component'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }